module.exports = __webpack_public_path__ + "static/media/CircuitbookingLogo.ee6d0bc1.png";